import React from "react";
import { useTranslation } from "react-i18next";

export default function Actuality({ title, content, img, url }) {
  const { t } = useTranslation();
  return (
    <div
      className="group bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer flex flex-col h-full border border-gray-100"
      onClick={() => window.open(url, "_blank")}
    >
      <div className="relative h-48 overflow-hidden">
        <img
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
          src={img}
          alt={title}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      </div>
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="text-xl font-bold text-vinefin-900 mb-3 line-clamp-2 group-hover:text-vinefin-700 transition-colors">
          {title}
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed line-clamp-4 flex-grow">
          {content}
        </p>
        <div className="mt-4 pt-4 border-t border-gray-100 text-vinefin-600 font-semibold text-sm flex items-center">
          {t("actualities.readmore")}
          <svg
            className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M17 8l4 4m0 0l-4 4m4-4H3"
            ></path>
          </svg>
        </div>
      </div>
    </div>
  );
}
